import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const StyledContainer = styled(FlexContainer)`
  height: 100vh;
  background: ${({ theme: { colors } }) => colors.iridiscent_gradient};
  align-items: center;
  justify-content: center;
  padding: ${({ theme: { sizing } }) => sizing.fds_size_64};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { reference } }) => reference.dimension_16};
  }
`;
